import type { NodeV2Style } from '@vedalib/editor'
import { css } from 'styled-components'

import { applyArea } from '../formControls/Area/utils'
import { PxSizesValueType } from '../formControls/Sizes/types'
import { safeParsePxSizes } from '../formControls/Sizes/utils'
import type { INodeV2StyledProps } from './NodeV2Styled'

const Area = (parent: NodeV2Style | null, style: NodeV2Style | null) => css`
  grid-area: ${applyArea(parent, style?.gridArea)};
`

const Absolute = (position?: string, margin?: PxSizesValueType) => css`
  position: ${position};
  width: ${position === 'absolute'
    ? `calc(100% - ${(margin?.[1] || 0) + (margin?.[3] || 0)}px)`
    : 'auto'};
  height: ${position === 'absolute'
    ? `calc(100% - ${(margin?.[0] || 0) + (margin?.[2] || 0)}px)`
    : 'auto'};
`

const GridItemStyled = ({ $parent, $parentStyle, $style }: INodeV2StyledProps) => css`
  z-index: ${$style?.zIndex || 1};

  ${!$parent?.repeatable && Absolute($style?.position, safeParsePxSizes($style?.margin))}

  ${!$parent?.repeatable && Area($parentStyle, $style)}
`

export default GridItemStyled
